export default "__VITE_ASSET__ChoWBYtX__"